export default __webpack_public_path__ + "static/media/pic_ip.c34da6df.png";